const articles = [
  {
    id: 1,
    language: 'Kotlin',
    title: 'Data class',
    description: 'In our work, we sometimes create classes that will only be used to contain data. With kotlin, "data classes" are more appropriate for this kind of task. It is easier to understand why this name.',
    date: 'Mars, 30 2019',
    link: 'https://medium.com/@lionel.kossi/build-your-first-api-using-rails-d090f142232f',
  },
  {
    id: 2,
    language: 'Ruby on Rails',
    title: 'Build your first API using Rails',
    description: 'I would like to share with you my latest experiences with Ruby on Rails, especially the creation of APIs. This may already speak to you. If so, that’s good otherwise let me introduce you to this pretty little world. Lately I had to work on a few applications using the Ruby on Rails framework. Regarding the creation of APIs with Ruby on Rails, I must say it is rather interesting. Being a framework, it remarkably facilitates the life of the developer.',
    date: 'Sep, 18 2022',
    link: 'https://medium.com/@lionel.kossi/build-your-first-api-using-rails-d090f142232f',
  },
  {
    id: 3,
    language: 'Ruby on Rails',
    title: 'Test your API endpoint',
    description: 'I would like to share with you my latest experiences with Ruby on Rails, especially the creation of APIs. This may already speak to you. If so, that’s good otherwise let me introduce you to this pretty little world. Lately I had to work on a few applications using the Ruby on Rails framework. Regarding the creation of APIs with Ruby on Rails, I must say it is rather interesting. Being a framework, it remarkably facilitates the life of the developer.',
    date: 'Sep 18 2022',
    link: 'https://medium.com/@lionel.kossi/build-your-first-api-using-rails-d090f142232f',
  },
];

export default articles;
